<style lang="sass" scoped>
@import "../../../../css/core";

.-time-pointer {
  position: absolute;
  background-color: $color-red;
}
</style>


<template>
<div v-if="onBusinessHour" class="-time-pointer" :style="style"></div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'time-pointer',
  props: {
    businessHour: {
      type: Object,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      required: true,
    },
    top: {
      default: 0,
      type: Number,
    },
    width: {
      default: 2,
      type: Number,
    },
    height: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      timerId: null,
      onBusinessHour: false,
      left: 0,
    }
  },
  computed: {
    style() {
      return {
        top: `${this.top}px`,
        left: `${this.left}px`,
        height: `${this.height}px`,
        width: `${this.width}px`,
      }
    },
  },
  methods: {
    update() {
      let range = moment.range(`${this.businessHour.openAt}/${this.businessHour.closeAt}`)
      let now = moment()
      this.onBusinessHour = range.contains(now)
      this.left = now.diff(range.start, 'minutes') * this.pxPerMinute
    },
  },
  ready() {
    this.update()
    this.timerId = setInterval(this.update, 60000)
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId)
    }
  },
}
</script>



// WEBPACK FOOTER //
// time-pointer.vue?5a4920c3